<script setup lang="ts">
/** Phase 17.10: a small "Advanced" pill with a lock, next to a feature the plan doesn't include. */
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
</script>

<template>
  <span
    class="inline-flex shrink-0 items-center gap-1 rounded-full bg-amber-100 px-1.5 py-px text-[10px] font-semibold uppercase tracking-wide text-amber-800 dark:bg-amber-950 dark:text-amber-300"
    :title="t('plan.lockedHint')"
  >
    <svg viewBox="0 0 16 16" class="h-2.5 w-2.5" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="3" y="7" width="10" height="7" rx="1.5" /><path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2" /></svg>
    {{ t('plan.advanced') }}
  </span>
</template>
